import styled from 'styled-components/macro';
import { Link as ReachRouterLink } from '@reach/router';

const Link = styled(ReachRouterLink as any)``;

export default Link;
